import { Box, Typography, useTheme } from '@mui/material'
import React, { useEffect } from 'react'
import MenuSection from '../components/MenuSection';
import { useNavigate } from 'react-router-dom';

export const GraciasPorComprarPage = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
          navigate("/tiendakioskpage", { state: { vieneDeFinalizar: true, limpiarProductos: true } });
        }, 6000);
    }, []);

  return (<>
  <MenuSection/>
    <Box sx={{backgroundColor: theme.bandera.colorSecundario, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
    <Typography variant='h3' color='white' textAlign='center'>
      ¡Gracias por tu compra!
    </Typography>
    </Box>
  </>
  )
}
